import { createContext } from 'react';
import type { useGlobalStateProvider } from './useGlobalStateProvider.ts';

type GlobalStateContextValue = ReturnType<typeof useGlobalStateProvider>;

/**
 * {@link GlobalStateContext} shares out miscellaneous global state that our app might need.
 */
export const GlobalStateContext = createContext<GlobalStateContextValue | undefined>(undefined);
